import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import Service from './pages/Service';
import OurCSR from './pages/OurCSR';
import Careers from './pages/Careers';
import HighlightsInsights from './pages/HighlightsInsights';
import ContactUs from './pages/ContactUs';
import { LanguageProvider } from './contexts/LanguageContext';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div>
          <Header />
          <ScrollToTop />
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/about-us" component={AboutUs} />
            <Route path="/service" component={Service} />
            <Route path="/our-csr" component={OurCSR} />
            <Route path="/careers" component={Careers} />
            <Route path="/highlights-insights" component={HighlightsInsights} />
            <Route path="/contact-us" component={ContactUs} />
          </Switch>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;